/*eslint-disable */
import axios from 'axios';
import root from '../_helpers/roots';
import { stat } from 'fs';
let pubQuizQlink = root.pubQuizQuestionLink.link;
let pubQuizRlink = root.pubQuizResultLink.link;

export default {
  state: {
    pubQuizQListState: {},
    pubQuizRState:{}
  },
  mutations: {
    pubQuizQLists(state, value) {
      state.pubQuizQListState = value;
    },
    pubQuizResult(state, value) {
      state.pubQuizRState = value;
    }
  },
  actions: {
    getPubQuizQuestionListFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(pubQuizQlink + payload.slug + '/')
          .then(function(response) {
            context.commit('pubQuizQLists', response.data);
            resolve(response.data);
          })
          .catch(
            function(err) {
              reject(err);
            }
          )
      })
    },
    getpubQuizResultFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(pubQuizRlink, payload)
          .then(function(response) {
            context.commit('pubQuizResult', response.data);
            resolve(response.data);
          })
          .catch(
            function(err) {
              reject(err);
            }
          )
      })
    }
  },
  getters: {
    pubQuizQListGetters: state => state.pubQuizQListState,
    pubQuizResultsGetters: state => state.pubQuizRState
  }
}